module.exports = __webpack_public_path__ + "img/robot-hide.2bbc2833.png";